<app-form-element [control]="formControl" [id]="id" [label]="label" [required]="required" [twoColumns]="twoColumns">
  <div class="content">
    @if (prefix) {
      <div [style.background-color]="backgroundColor" [style.color]="color" class="box-mask">
        <span>{{ prefix }}</span>
      </div>
    }
    <p-inputMask
      [formControl]="formControl"
      [mask]="mask"
      [placeholder]="mask"
      [style]="{ width: '100%' }"></p-inputMask>
  </div>
</app-form-element>
